<template>
	<!-- <el-card class="infobox" shadow="never">
		<div slot="header" class="clearfix flex" style="align-items: baseline">
			<h3>购买说明</h3>
		</div>
		
	</el-card> -->
	<div class="infobox">
		<ul>
			<li style="font-size: 15px;font-weight: bolder;color:#333333;">购买说明：</li>
			<li>1、标准文本（电子版）属于具有唯一性、时效性、版权保护需求的特殊商品。一经售出，不接受任何理由的退货或换货。如遇质量问题（文件打不开或下载不了），请与在线客服或客服电话联系；</li>
			<li>2、
				标准文本（纸质版）属于具有唯一性、时效性、版权保护需求的特殊商品。一经售出，非因质量问题（印刷错误、缺页、倒装、散页、污损），不接受任何理由的退货或换货。如存在影响正常阅读或使用的物理质量问题，可在签收之日起
				7 日（168 小时）内通过“特规通”平台申请退换货，申请时需要填写退换货理由，并上传相关证明图片，并与在线客服或客服电话联系；
			</li>
			<li>3、购买纸版商品时需要买家承担运费，实付满100元以下统一收取10元运费（偏远地区除外），实付满100元以上免运费（偏远地区除外），偏远地区统一收取20元运费；</li>
		</ul>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	methods: {}
};
</script>
<style lang="less" scoped>
.infobox {
	margin-bottom: 20px;
	// background-color: #ffffff;
	// box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
	// border-radius: 15px;
	h3 {
		margin: 0;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
	}
	ul {
		padding: 0;
		margin: 0;
	}
	li {
		color: rgb(96, 98, 102);
		font-size: 13px;
		font-weight: normal;
		line-height: 22px;
        list-style: none;
        margin-top: 8px;

		// position: relative;
		// padding-left: 14px;
		// margin-bottom: 8px;
		// line-height: 1.5;
		// color: #1f2329;
		// display: block;
		// font-size: 14px;

		// 添加蓝色小圆点
		// &::before {
		// 	content: '';
		// 	position: absolute;
		// 	left: 0;
		// 	top: 50%;
		// 	transform: translateY(-50%);
		// 	width: 5px;
		// 	height: 5px;
		// 	background-color: rgb(20, 86, 240);
		// 	border-radius: 50%;
		// }
	}
}

/deep/ .el-card__header {
	padding: 30px 30px 0;
	border-bottom: none;
}
/deep/ .el-card__body,
.el-main {
	padding: 20px 30px 40px;
}
//媒体查询-pad
@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
	.paymentlist {
		button + button {
			margin-left: 30px;
		}
	}
}
</style>
